import { z } from "zod";

export type Vin = string & { __brand: "Vin" };

const regexVin = /\b[(A-H|J-N|P|R-Z|0-9)]{17}\b/;

export const vinSchema = z
  .string()
  .regex(regexVin)
  .transform((s): Vin => s as Vin);
